import { Box, Button, Grid, Typography } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Add } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "shared/store/store";
import { Layout } from "shared/utils/ui/Layout";
import { useWidth } from "shared/hooks/HookDetailedConsultation/useWidth";
import { TableComponent } from "shared/components/Table.component";
import styles from "./styles/costCenter.module.scss";
import { useCostCenter } from "./hooks/useCostCenter";
import { IFieldForm } from "pages/read-documents/model/IFieldForm";

export const CostCenter = () => {
  const dispatch = useDispatch<Dispatch>();
  const { width } = useWidth();

  const {
    handleChange,
    handleSubmit,
    columns,
    valuesResultsPages,
    showForm,
    dataFields,
    getValue,
    toogleShowForm,
    createCostCenter,
    clearFilters,
  } = useCostCenter();

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(34);
  }, [dispatch.menuDrawer]);

  return (
    <Layout>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        marginTop={".3rem"}
      >
        <Typography className="titleMainLayout">
          Administración de Centro de Costos
        </Typography>
        <Box display={"flex"} gap={1}>
          <Button
            className={styles.buttonsActions}
            onClick={() => createCostCenter()}
            endIcon={<Add />}
            variant="contained"
            data-testid="btn-create-cost-center"
          >
            Crear centro de costo
          </Button>
          <Button
            className={styles.buttonsActions}
            onClick={toogleShowForm}
            endIcon={showForm ? <FilterAltOffIcon /> : <FilterAltIcon />}
            variant="contained"
            data-testid="btn-filters-cost-center"
          >
            Filtrar
          </Button>
        </Box>
      </Box>

      {showForm && (
        <form
          className={`${styles.formReadDocuments} form-documents`}
          noValidate
          onSubmit={handleSubmit}
          data-testid="form-cost-center-filters"
        >
          <Grid
            container
            direction={"row"}
            className={styles.containerReadDocuments}
          >
            {dataFields.map((field: IFieldForm, i: number) => (
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                className={styles.containerGridItem}
                key={i}
              >
                <label htmlFor={field.id}>{field.label}</label>
                <input
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  id={field.id}
                  data-testid={field.testId}
                  value={getValue(field.name)}
                  onChange={handleChange}
                />
              </Grid>
            ))}

            <Grid container direction={"row"} justifyContent={"center"}>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                className={styles.buttonSubmit}
                data-testid="btn-submit-cost-center"
              >
                Consultar
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={styles.buttonSubmit}
                data-testid="btn-clear-cost-center"
                onClick={clearFilters}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </form>
      )}

      <Box paddingTop={".5rem"} height={showForm ? "72%" : "89%"}>
        <TableComponent
          columns={columns}
          title=""
          valuesResultsPages={valuesResultsPages}
          classTotalElemnt={width < 500 ? "" : "classTotalElemnt"}
          showBtnCollapse={false}
          hiddenHeaderSearch={true}
          isSearch={false}
        />
      </Box>
    </Layout>
  );
};
